import { Box } from "@mui/material";
import { JSX } from "react";
import HowToWorks from "../how-to-works/how-to-works";
import PetCarousel from "../pet-carousel/PetCarousel";
import FadeInWhenVisible from "../animations/FadeInWhenVisible";
import SectionTitle from "../ui/SectionTitle";
import { sectionAccentLineSx } from "../../theme";

export default function InfoComponent(): JSX.Element {
    return (
        <>
            <Box
                sx={{
                    bgcolor: "background.default",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    flexDirection: "column",
                    pt: 4,
                    pb: 4,
                    width: "100%",
                }}
            >
                <FadeInWhenVisible variant="fade" timeout={600}>
                    <SectionTitle>О животных</SectionTitle>
                </FadeInWhenVisible>
                <FadeInWhenVisible variant="grow" timeout={700} rootMargin="0px 0px -40px 0px">
                    <Box sx={{ maxWidth: 1200, width: "100%", mt: 4, mb: 3 }}>
                        <PetCarousel />
                    </Box>
                </FadeInWhenVisible>
            </Box>
            <Box
                sx={{
                    bgcolor: "background.paper",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    flexDirection: "column",
                    pt: 4,
                    pb: 4,
                    width: "100%",
                }}
            >
                <FadeInWhenVisible variant="fade" timeout={600}>
                    <Box sx={sectionAccentLineSx} aria-hidden />
                </FadeInWhenVisible>
                <FadeInWhenVisible variant="grow" timeout={600} rootMargin="0px 0px -40px 0px">
                    <Box sx={{ maxWidth: 1200, width: "100%" }}>
                        <HowToWorks />
                    </Box>
                </FadeInWhenVisible>
            </Box>
        </>
    );
}
